// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Product from '../components/Product';
import {actions as ProductActions} from '../duck';
// import {actions as CategoryActions} from '../../categories/duck';
// import {actions as InformationActions} from '../../information/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    product: state.products.product,
    isFetching: state.products.isFetching,
    createFinalSettingProductSuccess:
      state.products.createFinalSettingProductSuccess,
    isSaving: state.products.isSaving,
    productOperationError:
      state.products.fetchProductsError ||
      state.products.saveProductError ||
      state.products.createProductError ||
      state.products.deleteProductError ||
      state.products.editProductError,
    fetchProductError: state.products.fetchProductError,
    createProductSuccess: state.products.createProductSuccess,
    editProductSuccess: state.products.editProductSuccess,
    deleteProductSuccess: state.products.deleteProductSuccess,
    store: state.store.store,
    user: state.auth.user,
    currency: state.currency.currency,
    storeInformation: state.ui.storeInformation,
    resellerInformation: state.ui.resellerInformation,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProductActions,
      },
      dispatch
    )
)(Product);
